

















































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseSortIcons from '@/ui/BaseSortIcons.vue';
// Importing functions
import {getStaff} from '@/ts/staff/get-staff';
import {deleteStaff} from '@/ts/staff/delete-staff';

export default {
    name: 'TheTableStaff',
    components: {
        BaseButton,
        BaseLoadingAnimation,
        BaseSortIcons,
    },
    props: {},
    data() {
        return {};
    },
    methods: {
        fireModal(id) {
            this.$swal.fire({
                title: 'Внимание!',
                text: 'Това действие е необратимо, желаете ли да продължите?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Отказ',
                confirmButtonText: 'Изтриване',
            }).then((result) => {
                if (result.value) {
                    deleteStaff(this.$route.params.id, id).then(() => {
                        this.$swal.fire(
                            'Изтриването успешно!',
                            '',
                            'success',
                        );
                        const index = this.$store.state.response.response.findIndex((item) => item.id === id);
                        this.$store.state.response.response.splice(index, index);
                    });
                }
            });
        },
        sort(temp) {
            this.$store.dispatch('setLoadingOn');
            this.$store.dispatch('setOrderParam', temp.order_param);
            this.$store.dispatch('setSortParam', temp.sort_param);
            getStaff(this.$route.params.id).then(() => {
                this.$store.dispatch('setLoadingOn');
            });
        },
    },
};
